// 画像サムネイル表示する際はこちらのクラスを利用
$('#datatable-show-image-products').dataTable({
  order: [ [ 1, "asc" ] ],
  "pageLength": 50
});
